import type { RouteObject } from "react-router-dom";
import { pathname } from "#src/config/pathname";

import AllSolutionPage from "#src/pages/solutions";

export const allSolutionRoute: RouteObject = {
  path: pathname.SOLUTIONS,
  children: [
    {
      index: true,
      element: <AllSolutionPage />,
    },
  ],
};
